import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";
import { DataService } from './DataServices/data.service';
import { NotificationService } from './notification.service';
import { LangsRepository } from './langs.repository';
import { WhatsAppDataService } from "./DataServices/whatsApp.data.service";
import { WhatsappService } from "./whatsapp.service";
import { environment } from '../../environments/environment';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Platform } from '@ionic/angular';
import { AppService } from './app.service';
var AuthService = /** @class */ (function () {
    function AuthService(dataService, whatsAppDataService, notificationService, whatsappService, langsRepository, router, inAppBrowser, platform, appService) {
        var _this = this;
        this.dataService = dataService;
        this.whatsAppDataService = whatsAppDataService;
        this.notificationService = notificationService;
        this.whatsappService = whatsappService;
        this.langsRepository = langsRepository;
        this.router = router;
        this.inAppBrowser = inAppBrowser;
        this.platform = platform;
        this.appService = appService;
        this.authenticated = false;
        this.user = null;
        this.prevUrl = "";
        this.hasRestriction = function (type) {
            if (!_this.user || !_this.user.activeRestrictions) {
                return false;
            }
            return _this.user.activeRestrictions.some(function (i) { return i.restriction === type; });
        };
        var authData = this.readAuthData();
        if (authData) {
            if (authData.user) {
                this.dataService.userId.next(authData.user.id);
            }
            this.dataService.jwt.next(authData.jwt || "");
            this.dataService.token.next(authData.token);
            this.user = authData.user;
            this.notificationService.subscribe(this.user.id, !!(this.user && this.user.whatsappPhones && this.user.whatsappPhones.length > 0));
            this.whatsappService.subscribe(this.user);
            this.authenticated = true;
        }
    }
    Object.defineProperty(AuthService.prototype, "authKey", {
        get: function () {
            var isInIframe = (parent !== window);
            var hostname = isInIframe ? document.referrer : window.location.hostname;
            return "fxa-" + hostname;
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.forgotPassword = function (username) {
        var locale = this.langsRepository.current.locale;
        return this.dataService.forgotPassword(username, locale);
    };
    AuthService.prototype.getToken = function () {
        return this.dataService.token.value;
    };
    AuthService.prototype.getJwt = function () {
        return this.dataService.jwt.value;
    };
    AuthService.prototype.getServerApplicationVersion = function () {
        return this.dataService.getCurrentVersionFromServer();
    };
    AuthService.prototype.saveAuthData = function (authData) {
        var _this = this;
        if (authData.user) {
            this.dataService.userId.next(authData.user.id);
        }
        // Only overwrite jwt/token when explicitly provided; preserves existing auth when just updating user
        if (authData.jwt !== undefined) {
            this.dataService.jwt.next(authData.jwt || "");
        }
        if (authData.token !== undefined) {
            this.dataService.token.next(authData.token);
        }
        this.user = authData.user;
        console.log('saveAuthData', authData ? authData.user.email : "", this.authKey, authData);
        var toStore = {
            token: authData.token !== undefined ? authData.token : this.dataService.token.value,
            jwt: authData.jwt !== undefined ? (authData.jwt || "") : this.dataService.jwt.value,
            user: authData.user
        };
        localStorage.setItem(this.authKey, JSON.stringify(toStore));
        Sentry.configureScope(function (scope) {
            if (_this.user) {
                scope.setUser({
                    id: _this.user.id.toString(),
                    email: _this.user.email,
                    username: _this.user.firstName + " " + _this.user.lastName,
                });
            }
        });
        setTimeout(function () {
            if (_this.user) {
                _this.notificationService.subscribe(_this.user.id, !!(_this.user && _this.user.whatsappPhones && _this.user.whatsappPhones.length > 0));
                _this.whatsappService.subscribe(_this.user);
            }
        }, 1000);
        this.authenticated = true;
    };
    AuthService.prototype.logout = function () {
        if (this.user) {
            this.notificationService.unsubscribe(this.user.id);
            this.whatsappService.unsubscribe(this.user);
        }
        console.log('logout');
        localStorage.removeItem(this.authKey);
        this.dataService.userId.next(null);
        this.dataService.jwt.next("");
        this.dataService.token.next("");
        this.user = null;
        this.authenticated = false;
    };
    /**
     * Logout and redirect to backend. Use from menu to avoid lazy auth-module load.
     * Defers logout and redirect so menu-close animation does not interfere.
     * On Cordova (especially after force-stop cold start), uses InAppBrowser _self
     * for more reliable navigation than window.location.href.
     */
    AuthService.prototype.logoutAndRedirect = function () {
        var _this = this;
        var base = (environment.baseUrlV1 && environment.baseUrlV1.replace(/\/api\/crm\/webapp\/v1\/?$/, '')) || '';
        var frontReturn = "" + window.location.origin + window.location.pathname + "#/";
        var url = base + "/api/crm/webapp/v1/auth/logout?returnUrl=" + encodeURIComponent(frontReturn);
        var isCordova = this.platform.is('cordova');
        var delay = isCordova ? 800 : 350;
        setTimeout(function () {
            _this.logout();
            if (isCordova) {
                _this.inAppBrowser.create(url, '_self');
            }
            else {
                window.location.href = url;
            }
        }, delay);
    };
    AuthService.prototype.updateUser = function (user, token, jwt) {
        var _this = this;
        if (jwt === void 0) { jwt = ""; }
        this.notificationService.unsubscribe(this.user.id);
        this.whatsappService.unsubscribe(this.user);
        this.user = user;
        var authData = { token: token, jwt: jwt, user: this.user };
        console.log('updateUser', authData ? authData.user.email : "", this.authKey, authData);
        localStorage.setItem(this.authKey, JSON.stringify(authData));
        setTimeout(function () {
            _this.notificationService.subscribe(_this.user.id, !!(_this.user && _this.user.whatsappPhones && _this.user.whatsappPhones.length > 0));
            _this.whatsappService.subscribe(_this.user);
        }, 1000);
        if (authData.user) {
            this.dataService.userId.next(authData.user.id);
        }
        this.dataService.jwt.next(jwt || "");
        this.dataService.token.next(token);
    };
    AuthService.prototype.updateUserSettings = function (user) {
        var authData = this.readAuthData();
        if (!authData) {
            return;
        }
        console.log('updateUserSettings', authData ? authData.user.email : "", this.authKey, authData);
        authData.user = user;
        localStorage.setItem(this.authKey, JSON.stringify(authData));
    };
    AuthService.prototype.getPaymentIframe = function (token, login) {
        return this.dataService.blt_getPaymentIframe(token, this.langsRepository.current.locale, login);
    };
    AuthService.prototype.addUserBySms = function (token, smsCode, login) {
        return this.dataService.blt_addUserBySms(token, smsCode, login, this.langsRepository.current.locale);
    };
    AuthService.prototype.setWhatsAppToken = function (token) {
        this.whatsAppDataService.token.next(token);
    };
    AuthService.prototype.getUserByWhatsAppToken = function () {
        var _this = this;
        this.whatsAppDataService.getUserByToken().subscribe(function (res) { _this.user = res.data; });
    };
    AuthService.prototype.getMe = function () {
        return this.dataService.authMe();
    };
    AuthService.prototype.getOidcUrl = function (returnUrl) {
        return this.dataService.getOidcUrl(returnUrl);
    };
    /**
     * Start OIDC login by redirecting the browser to the backend initiate endpoint.
     * On Cordova, uses InAppBrowser so the main WebView stays in the app; on web, redirects in place.
     */
    AuthService.prototype.startOidcLogin = function (callbackUrl) {
        var _this = this;
        var isCordova = this.platform.is('cordova');
        if (isCordova) {
            this.startOidcLoginInAppBrowser(callbackUrl);
            return;
        }
        this.getOidcUrl(callbackUrl).subscribe(function (res) {
            if (res && res.responseCode === 200 && res.data && res.data.url) {
                window.location.href = res.data.url;
                return;
            }
            _this.redirectToOidcFallback(callbackUrl);
        }, function (_err) {
            _this.redirectToOidcFallback(callbackUrl);
        });
    };
    /**
     * OIDC login in InAppBrowser so the main WebView stays on the local app.
     * When the callback URL loads, we intercept, extract token/jwt, close the browser, and navigate.
     */
    AuthService.prototype.startOidcLoginInAppBrowser = function (callbackUrl) {
        var _this = this;
        this.getOidcUrl(callbackUrl).subscribe(function (res) {
            var url = (res && res.responseCode === 200 && res.data && res.data.url)
                ? res.data.url
                : _this.getOidcFallbackUrl(callbackUrl);
            _this.openOidcInAppBrowser(url);
        }, function (_err) {
            _this.openOidcInAppBrowser(_this.getOidcFallbackUrl(callbackUrl));
        });
    };
    AuthService.prototype.openOidcInAppBrowser = function (url) {
        var _this = this;
        var browser = this.inAppBrowser.create(url, '_blank', 'location=yes');
        var callbackPath = 'auth/callback';
        browser.on('loadstart').subscribe(function (ev) {
            var u = ev.url || '';
            if (u.indexOf(callbackPath) === -1)
                return;
            var token = _this.parseCallbackParam(u, 'token');
            var jwt = _this.parseCallbackParam(u, 'jwt');
            var error = _this.parseCallbackParam(u, 'error');
            if (error) {
                browser.close();
                _this.appService.showError('Authentication Error', "Login failed: " + error, true);
                return;
            }
            if (token || jwt) {
                browser.close();
                _this.dataService.jwt.next(jwt || '');
                _this.dataService.token.next(token || '');
                sessionStorage.removeItem('oidc-login-retry');
                _this.getMe().subscribe(function (meRes) {
                    if (meRes.body && meRes.body.responseCode === 200 && meRes.body.data) {
                        var user = meRes.body.data;
                        _this.saveAuthData({
                            token: token || '',
                            jwt: jwt || '',
                            user: user
                        });
                        _this.router.navigateByUrl(_this.prevUrl || '/leadClients');
                    }
                    else {
                        _this.appService.showError('Authentication Error', 'Failed to get user information', true);
                        _this.router.navigateByUrl('/auth/login');
                    }
                }, function (err) {
                    _this.appService.showError('Authentication Error', _this.appService.getErrorMessage(err), true);
                    _this.router.navigateByUrl('/auth/login');
                });
            }
        });
    };
    AuthService.prototype.parseCallbackParam = function (url, name) {
        var hashIdx = url.indexOf('#');
        var afterHash = hashIdx >= 0 ? url.substring(hashIdx + 1) : url;
        var qIdx = afterHash.indexOf('?');
        var queryString = qIdx >= 0 ? afterHash.substring(qIdx + 1) : '';
        return new URLSearchParams(queryString).get(name);
    };
    AuthService.prototype.getOidcFallbackUrl = function (callbackUrl) {
        var base = (environment.baseUrlV1 || '').replace(/\/api\/crm\/webapp\/v1\/?$/, '');
        if (base.startsWith('http://'))
            base = 'https://' + base.substring(7);
        return base + "/api/crm/webapp/v1/auth/initiate-oidc?returnUrl=" + encodeURIComponent(callbackUrl);
    };
    AuthService.prototype.getOidcCallbackUrl = function () {
        var isCordova = typeof window !== "undefined" && !!window.cordova;
        if (isCordova) {
            var baseFixUrl = (environment.baseFixUrl || "").replace(/\/+$/, "");
            if (baseFixUrl) {
                return baseFixUrl + "/#/auth/callback";
            }
        }
        return "" + window.location.origin + window.location.pathname + "#/auth/callback";
    };
    AuthService.prototype.redirectToOidcFallback = function (callbackUrl) {
        var fallbackBaseUrl = (environment.baseUrlV1 && environment.baseUrlV1.replace(/\/api\/crm\/webapp\/v1\/?$/, ''))
            || '';
        if (fallbackBaseUrl.startsWith("http://")) {
            fallbackBaseUrl = "https://" + fallbackBaseUrl.substring("http://".length);
        }
        window.location.href = fallbackBaseUrl + "/api/crm/webapp/v1/auth/initiate-oidc?returnUrl=" + encodeURIComponent(callbackUrl);
    };
    AuthService.prototype.readAuthData = function () {
        var raw = localStorage.getItem(this.authKey);
        if (!raw) {
            return null;
        }
        try {
            return JSON.parse(raw);
        }
        catch (_err) {
            // Corrupted/stale auth payload should not break app startup.
            localStorage.removeItem(this.authKey);
            return null;
        }
    };
    return AuthService;
}());
export { AuthService };
